import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router, CanActivate, CanLoad } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RandomGuardService implements CanActivate, CanLoad {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate() {
    return this.canLoad();
  }

  canLoad() {

    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
    }
    return this.authService.isLoggedIn();
  }
}
